import { Module } from '../models/module.model';

export class AddModules {
    static readonly type = '[Module] AddModules';

    constructor(public payload: Module[]) {}
}
